<script>
import Swal from "sweetalert2";

// Custom Components
import BookingService from "@/helpers/APIService/booking.service";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";

export default {
  props: {
    currentProps: Object,
  },
  data() {
    return {
      upsellList: [],
      chargeType: "",
      orderLength: 0,
      selectedUpsellId: "",
      isBtnLoading: false,
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getUpSellList();
    this.getChargeTypeList();
  },
  methods: {
    // Method is used for getting charge type list
    async getChargeTypeList() {
      await UserService.getChargesTypeList().then((charges) => {
        charges.map((charge) => {
          if (charge.name == "Upsell") {
            this.chargeType = charge.id;
          }
        });
      });
    },

    // Method is used for getting upSell list
    async getUpSellList() {
      const query = "?is_active=true";
      await UserService.getAllUpSell(query)
        .then((upsell) => {
          if (upsell != null && upsell != "") {
            upsell.map((item) => {
              if (item.booking_source.length > 0) {
                let bookingSource = [];
                item.booking_source.map((source) => {
                  bookingSource.push(source.id);
                });
                if (
                  this.currentProps.booking &&
                  this.currentProps.booking.booking_source &&
                  this.currentProps.booking.booking_source.id &&
                  bookingSource.includes(
                    this.currentProps.booking.booking_source.id
                  )
                ) {
                  this.upsellList.push({
                    ...item,
                    upSellOrder: [],
                    isDisable: false,
                    totalPurchase: 0,
                  });
                }
              }
            });
          }
          this.getUpSellOrderList();
        })
        .catch((error) => {
          errorHandler(error);
        });
    },

    // Method is used for getting upSell Order list
    getUpSellOrderList() {
      this.orderLength = 0;
      if (
        this.currentProps.booking &&
        this.currentProps.booking.upsell_order &&
        this.currentProps.booking.upsell_order.length > 0
      ) {
        this.currentProps.booking.upsell_order.map((order_transaction) => {
          // set box dynamic color variable
          let color;
          if (order_transaction.approve_status == "rejected") {
            color = "bg-danger border-danger";
          } else if (order_transaction.approve_status == "void") {
            color = "bg-dark border-dark";
          } else if (order_transaction.approve_status == "pending") {
            color = "bg-warning border-warning";
          } else if (order_transaction.approve_status == "approved") {
            color = "bg-success border-success";
          } else {
            color = "bg-primary border-primary";
          }
          // push orders data in orderList array
          order_transaction.color = color;
          this.upsellList = this.upsellList.map((upsell) => {
            if (upsell.id == order_transaction.upsell.id) {
              upsell.upSellOrder.push(order_transaction);
              if (order_transaction.upsell.base_on == "item") {
                upsell.totalPurchase += 1;
              } else {
                upsell.isDisable = true;
              }
            }
            return {
              ...upsell,
              order_status: color,
              approve_status: order_transaction.approve_status,
            };
          });
        });
        this.orderLength = this.currentProps.booking.upsell_order.length;
      }
    },

    // Method is used for adding upSell Order and charges
    async addUpsell(upsell, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "Confirm upsell order!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Confirm!",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.value) {
          try {
            this.selectedUpsellId = upsell.id;
            this.isBtnLoading = true;
            let extraCharges = upsell.price;

            // check selected upsell price type [percentage, amount]
            if (upsell.price_type == "percentage") {
              extraCharges =
                parseFloat(
                  this.currentProps.booking.reservation_charge * extraCharges
                ) / 100;
            }

            // check selected upsell base on [guest or adult, booking, item]
            if (upsell.base_on == "guest" || upsell.base_on == "adult") {
              extraCharges =
                parseFloat(this.currentProps.booking.guest.length) *
                parseFloat(upsell.price);
            }

            // check selected upsell period [daily, one_time]
            if (upsell.period == "daily") {
              extraCharges =
                parseFloat(this.currentProps.booking.stay_night) *
                parseFloat(extraCharges);
            }

            // check selected upsell in approval is required or not
            let is_approval_required;
            if (!upsell.is_approval_required) {
              is_approval_required = "approved";
            } else {
              is_approval_required = "pending";
            }

            // add upsell order api calling
            await BookingService.addUpsellOrder(this.currentProps.booking.id, {
              hotel: this.hotel.id,
              booking: this.currentProps.booking.id,
              guest: this.currentProps.booking.primary_guest.id,
              upsell: upsell.id,
              approve_status: is_approval_required,
              total_item: 1,
              is_mandatory_purchase: upsell.is_mandatory,
              amount: parseInt(extraCharges),
            }).then((result) => {
              this.orderLength = parseInt(this.orderLength) + 1;
              if (is_approval_required == "approved") {
                // add additional charges api calling
                BookingService.addAdditionalCharge(
                  this.currentProps.booking.id,
                  {
                    booking: this.currentProps.booking.id,
                    description: upsell.short_description,
                    debit: parseInt(extraCharges),
                    charge_type: this.chargeType,
                    upsell: upsell.id,
                    folio_transaction: result.folio_transaction,
                  }
                )
                  .then(async (res) => {
                    // update upsell order  api calling
                    await BookingService.updateUpsellOrder(
                      this.currentProps.booking.id,
                      result.id,
                      {
                        approve_status: "approved",
                        total_item: 1,
                        is_mandatory_purchase: upsell.is_mandatory_purchase,
                        folio_transaction: res.id,
                      }
                    ).then((result) => {
                      // emit event calling for payment tab
                      this.$root.$emit("new_charge_added", true);
                      if (res != "" && res != null) {
                        this.handleUpsellOrder(
                          result,
                          "bg-success border-success",
                          index
                        );
                      }
                      Middleware.notification(
                        "Order added successfully !!",
                        "success",
                        3000
                      );
                      this.selectedUpsellId = "";
                      this.isBtnLoading = false;
                    });
                  })
                  .catch((error) => {
                    this.selectedUpsellId = "";

                    this.isBtnLoading = false;
                    errorHandler(error);
                  });
              } else {
                this.handleUpsellOrder(
                  result,
                  "bg-warning border-warning",
                  index
                );
                Middleware.notification(
                  "Please approve upSell to add !!",
                  "info",
                  5000
                );
                this.selectedUpsellId = "";
                this.isBtnLoading = false;
              }
            });
          } catch (error) {
            this.isBtnLoading = false;
            this.selectedUpsellId = "";
            Middleware.notification("Something went wrong !!", "danger", 3000);
          }
        }
      });
    },
    // Method is used to handle upsell order with upsell list
    handleUpsellOrder(upsell_order, color, index) {
      this.upsellList.map((upsell) => {
        if (upsell.id == upsell_order.upsell.id) {
          upsell.upSellOrder.push(upsell_order);
          if (upsell_order.upsell.base_on == "item") {
            upsell.totalPurchase += 1;
          } else {
            upsell.isDisable = true;
          }
          const upsellData = {
            ...upsell,
            order_status: color,
            approve_status: upsell_order.approve_status,
          };
          this.$set(this.upsellList, index, upsellData);
        }
      });
    },
  },
};
</script>

<template>
  <b-tab>
    <template v-slot:title>
      <span class="d-inline-block d-sm-none">
        <i class="fas fa-home"></i>
      </span>
      <span class="d-none d-sm-inline-block">Upsell</span>
    </template>
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <h4 class="header-title text-primary mb-0">
            Add-on Services Purchased
            <span class="badge badge-soft-primary">{{ orderLength }}</span>
          </h4>
        </div>

        <b-card class="mb-0">
          <div class="addon-scrollbar">
            <div class="d-flex align-items-start flex-wrap">
              <div
                v-for="(product, index) in upsellList"
                :key="index"
                class="card add-on-box text-center border-primary p-2 d-flex align-items-center justify-content-center"
              >
                <div>
                  <!-- Not purchased UpSell -->
                  <div>
                    <h5 class="text-primary mb-3">
                      {{ product.title
                      }}<i
                        class="fas fa-crown ms-3 fs-5 text-warning"
                        v-if="product.is_premium_upsell"
                      ></i>
                      <span
                        class="font-size-12 text-dark"
                        v-show="product.period == 'daily'"
                      >
                        ({{ "Per Night" }})
                      </span>
                    </h5>
                    <img
                      :src="
                        product.image != '' && product.image != null
                          ? product.image
                          : 'data:image/png;base64,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'
                      "
                      alt="upsell"
                    />
                    <p class="my-2 fs-5">$ {{ product.price }}</p>
                    <button
                      v-if="!product.isDisable"
                      class="add-on-btn bg-primary border-primary text-light"
                      @click="addUpsell(product, index)"
                      :class="{ disabled: isBtnLoading }"
                    >
                      <i
                        v-if="isBtnLoading && selectedUpsellId == product.id"
                        class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                      ></i>
                      Add-On
                      <span v-if="product.totalPurchase !== 0"
                        >({{ product.totalPurchase }})</span
                      >
                    </button>
                    <button
                      v-else
                      class="add-on-btn text-light text-capitalize"
                      :class="product.order_status"
                      disabled
                    >
                      {{ product.approve_status }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </b-tab>
</template>

<style scoped>
.add-on-box {
  min-height: 230px;
  margin: 10px;
  border-radius: 10px;
  width: 250px;
}

.add-on-box img {
  max-width: 80px;
  max-height: 80px;
}

.add-on-btn {
  border-radius: 6px;
  padding: 4px 14px;
}

.addon-scrollbar {
  max-height: calc(100vh - 270px);
  overflow-y: auto;
}
.upShellIcon {
  position: absolute;
  top: 0px;
  right: 0px;
}
</style>
